<template>
  <main class="container">
    <h2>Histórico de Solicitações</h2>
    <div class="historico-licencas">
      <template v-if="historicos.length">
        <HistoricoCard
          v-for="(historico, index) in historicos"
          :key="index"
          :data="historico"
        />
      </template>
      <p v-else>Nenhum histórico encontrado.</p>
    </div>
  </main>
</template>

<script>
import HistoricoCard from "./HistoricoCard.vue";
import ConsultaService from "@/services/ConsultaService"; // Certifique-se de que o caminho está correto

export default {
  components: { HistoricoCard },
  data() {
    return {
      historicos: []
    };
  },
  computed: {
    usuarioLogado() {
      return this.$store.getters["usuarioLogado"];
    }
  },
  watch: {
    usuarioLogado: {
      handler() {
        this.carregarHistorico();
      },
      deep: true
    }
  },
  mounted() {
    this.carregarHistorico();
  },
  methods: {
    carregarHistorico() {
      const usuario = this.usuarioLogado;
      if (!usuario || !usuario.login) {
        return;
      }
      const identificador = encodeURIComponent(usuario.login);
      ConsultaService.consultarHistoricoCarteira(identificador)
        .then(response => {
          const licencas = [
            ...response.data.licencasEsportivas,
            ...response.data.licencasRecreativas
          ];
          this.historicos = licencas
            .sort((a, b) => new Date(b.cadastro) - new Date(a.cadastro))
            .map(item => ({
              numero: item.numero,
              modalidade: item.modalidade,
              ativacao: item.ativacao,
              vencimento: item.vencimento,
              status: item.status
            }));
        })
        .catch(error => {
          console.error("Erro ao consultar histórico:", error);
        });
    }
  }
};
</script>

<style scoped>
.container {
  padding: 25px 29px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: white;
  margin-top: 40px;
}
.historico-licencas {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 7px;
}
.container h2 {
  margin: 0 0 19px 0;
}
.historico-licencas p {
  text-align: center;
  color: #666;
  font-size: 1rem;
}
</style>
